const STORAGE_PREFIX = "ticketapp:linked-coupon:";
const memoryCoupons = new Map();

const normalizeCode = (value) => {
  const code = Array.isArray(value) ? value[0] : value;
  return typeof code === "string" ? code.trim().toUpperCase().slice(0, 64) : "";
};

const getScope = (route = {}, isDomain = false) => {
  if (typeof window === "undefined") return "";
  const host = window.location.host.toLowerCase();
  const platformHost = host.includes(".ticketapp.cl") ||
    host.includes("localhost") || host.includes("192.168") || host.includes("10.0");
  const slug = route.params && route.params.name;
  return platformHost && !isDomain && slug
    ? `${host}/${String(slug).toLowerCase()}`
    : host;
};

export const rememberLinkedCoupon = (route, isDomain = false) => {
  const code = normalizeCode(route && route.query && route.query.cupon);
  const scope = getScope(route, isDomain);
  if (!code || !scope) return "";
  memoryCoupons.set(scope, code);
  try {
    window.sessionStorage.setItem(`${STORAGE_PREFIX}${scope}`, code);
  } catch (error) {
    // Keep the code for this tab even when storage is unavailable.
  }
  return code;
};

export const getLinkedCoupon = (route, isDomain = false) => {
  const scope = getScope(route, isDomain);
  if (!scope) return "";
  if (memoryCoupons.has(scope)) return memoryCoupons.get(scope);
  try {
    return normalizeCode(window.sessionStorage.getItem(`${STORAGE_PREFIX}${scope}`));
  } catch (error) {
    return "";
  }
};

export const clearLinkedCoupon = (route, isDomain = false) => {
  const scope = getScope(route, isDomain);
  if (!scope) return;
  memoryCoupons.delete(scope);
  try {
    window.sessionStorage.removeItem(`${STORAGE_PREFIX}${scope}`);
  } catch (error) {
    // The in-memory copy was cleared even if storage is unavailable.
  }
};
